import { logEvent } from 'firebase/analytics';
import { analytics } from '../../firebase';

export const analyticsService = {
  logEvent: (eventName, eventParams) => {
    if (analytics) {
      logEvent(analytics, eventName, eventParams);
    } else {
      console.log('Analytics Event (dev):', eventName, eventParams);
    }
  }
}; 